import React, { useState } from "react";
import { Link } from "react-router-dom";
import "../../styles/About/About.scss";
import "../../styles.css"; // Import the generalized CSS styles

const About = ({ darkTheme }) => {
  const text = "ABOUT.";
  const [hoveredIndices, setHoveredIndices] = useState(new Set());

  const handleMouseOver = (index) => {
    setHoveredIndices((prev) => new Set(prev.add(index)));
  };

  const handleMouseOut = (index) => {
    // Optional: Remove this function if you want to keep the hover effect persistent
  };

  return (
    <div className={`about ${darkTheme ? "dark" : "light"}`} id="about">
      <div className="about__container">
        <div className="about__header" id="about__heading">
          <h1 data-aos="fade-down" className="text-wrapper">
            {text.split("").map((char, index) => (
              <span
                key={index}
                className={hoveredIndices.has(index) ? "gradient-text" : ""}
                onMouseOver={() => handleMouseOver(index)}
                onMouseOut={() => handleMouseOut(index)} // Optional: Remove this if you don't need to reset hover
                style={{ color: darkTheme ? "white" : "black" }}
              >
                {char === " " ? "\u00A0" : char}
              </span>
            ))}
          </h1>
        </div>
        <div className="about__details-container">
          <div
            className="about__details"
            data-aos="fade-down"
            data-aos-offset="0"
            data-aos-delay="0"
            data-aos-once="true"
          >
            <Link to="/about/intro">
              <h1>
                0<span>1</span>
              </h1>
              <h2>
                H<span>ello,</span>
              </h2>
              <p style={{ color: darkTheme ? "white" : "black" }}>
                I am <span>Mohd Aquib.</span> <br /> Highly passionate Data
                Scientist with more than 4 years of experience.
              </p>
            </Link>
          </div>
          <div
            className="about__details"
            data-aos="fade-down"
            data-aos-offset="-180"
            data-aos-delay="200"
            data-aos-once="true"
          >
            <Link to="/about/experience">
              <h1>
                0<span>2</span>
              </h1>
              <h2>
                E<span>xperience</span>
              </h2>
              <p style={{ color: darkTheme ? "white" : "black" }}>
                <span>More than 4 years of experience.</span>
                <br />I specialize in transforming data into actionable
                insights, utilizing advanced tools like TensorFlow and PyTorch
                to inform strategic decisions.
              </p>
            </Link>
          </div>
          <div
            className="about__details"
            data-aos="fade-down"
            data-aos-offset="50"
            data-aos-delay="500"
            data-aos-once="true"
          >
            <Link to="/about/internships">
              <h1>
                0<span>3</span>
              </h1>
              <h2>
                I<span>nternships</span>
              </h2>
              <p>
                <span style={{ color: darkTheme ? "white" : "black" }}>
                  Interned at -
                </span>{" "}
                <br />
              </p>
              <ul>
                <li>
                  <span style={{ color: darkTheme ? "white" : "black" }}>
                    Wobot Intelligence
                  </span>{" "}
                  - Computer Vision Intern{" "}
                </li>
              </ul>
            </Link>
          </div>
          <div
            className="about__details"
            data-aos="fade-down"
            data-aos-offset="-180"
            data-aos-delay="700"
            data-aos-once="true"
          >
            <Link to="/about/graduation">
              <h1>
                0<span>4</span>
              </h1>
              <h2>
                E<span>ngineering</span>
              </h2>
              <p style={{ color: darkTheme ? "white" : "black" }}>
                <span>Aligarh Muslim University </span>
                <br />
                Master's in Computer Science and Applications (2019 - 2022),
                preceded by a B.Sc (Hons) in Computer Science (2016 - 2019).
              </p>
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
